import React, { useCallback } from 'react'
import { getFormValue } from '../../utility'
import { useInstData, useEventHandler } from 'tyan/public/hooks'

const ExportColumns = props => {
	const { showBody: Body, defaults, descs, selected, total, onExport, onClose } = props
	const { me } = useInstData(props, () => ({
		state: {
			initValuesBasic: { descs: defaults, data: selected && selected != total ? 'selected' : 'all' },
			changedValuesBasic: {}
		}
	}))

	const dataItems = [[`${Tyan.t('全部')} ${total} ${Tyan.t('条记录')}`, 'all']]
	selected && selected != total && dataItems.unshift([`${Tyan.t('已选择')} ${selected} ${Tyan.t('条记录')}`, 'selected'])

	const choiced = getFormValue(me, 'Basic', 'descs') || []
	const data = getFormValue(me, 'Basic', 'data')
	const canExport = choiced.length && data

	const handleExport = useEventHandler(() => {
		if (!choiced.length || !data)
			return
		onExport(choiced, data)
	})

	const localeDescs = descs.map(text => ([Tyan.t(text, 'columnText'), text]))
	// console.log('decs:', descs)

	return <Body data={me} maxWidth="800"
		controls={
			[
				{ _button: '确定', /* icon: 'download', */ handler: handleExport, disabled: !canExport },
				{ _button: '取消', /* icon: 'close',  */handler: onClose },
			]}
		fieldsets={
			[
				{
					title: '', name: 'Basic', _fieldset: [
						{ _radio: '数据', itemNoLocale: true, required: true, name: 'data', items: dataItems, minWidth: '90%' },
						{ _checkbox: '字段', required: true, name: 'descs', items: localeDescs },
					]
				},
			]}
	/>
}

export default ExportColumns